import { render } from "./SkychartObjectsDetails.vue?vue&type=template&id=b30ee49a"
import script from "./SkychartObjectsDetails.vue?vue&type=script&lang=js"
export * from "./SkychartObjectsDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__